import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { AccessRightDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-access-right',
  templateUrl: './access-right.component.html',
  styleUrls: ['./access-right.component.scss'],
})
export class AccessRightComponent implements OnChanges {
  accessrightForm: FormGroup;
  accessrightFormArray: FormGroup;
  control = new FormControl();
  @Input() accessrights: AccessRightDto[];
  @Input() routeAnimationsElements: any;
  @Output() accessright = new EventEmitter<AccessRightDto[]>();
  @Output() deleteAccessRightEvent = new EventEmitter<any>();

  selectedAccessRight: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createAccessRightForm();
  }

  createAccessRightForm() {
    this.accessrightForm = this.fb.group({
      value: ['', Validators.required],
      ModuleActivity_ActivityId: ['', Validators.required],
      id: null,
    });
    this.accessrightFormArray = this.fb.group({
      AccessRights: this.fb.array([]),
    });
    this.setAccessRight();
  }

  // method to display accessrights
  setAccessRight() {
    const control = this.accessrightFormArray.controls
      .AccessRights as FormArray;
    this.accessrights.forEach((e) => {
      control.push(
        this.fb.group({
          value: e.value,
          ModuleActivity_ActivityId: e.ModuleActivity_ActivityId,
          id: e.id,
        })
      );
    });
  }

  // method to add AccessRight
  addAccessRight(value: AccessRightDto) {
    const control = this.accessrightFormArray.controls
      .AccessRights as FormArray;
    control.insert(
      0,
      this.fb.group({
        value: value.value,
        ModuleActivity_ActivityId: value.ModuleActivity_ActivityId,
        id: null,
      })
    );
  }

  selectAccessRight(value) {}

  // method to delete accessright from arrary list
  deleteAccessRight(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.accessrightFormArray.controls
          .AccessRights as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.accessrights.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.accessrights[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: AccessRightDto) {
    if (this.accessrightForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.accessrightFormArray
        .get('AccessRights')
        ['controls'][this.selectedIndex].patchValue({
          value: formValue.value,
        });
    } else {
      this.addAccessRight(formValue);
    }
    this.selectedIndex = null;
    this.accessrightForm.reset();
  }

  onEdit(index, value: AccessRightDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.accessrightForm.patchValue({ value: value.value });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.accessrightForm.reset();
  }

  onSubmit(formValue: AccessRightDto[]) {
    this.accessright.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteAccessRightEvent.emit(this.filteredDelete);
    }
  }
}
